import { Html, OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber"
import { AnimatePresence, motion } from "framer-motion";
import React, { Suspense, useEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import { Clouds } from "../components/Clouds";
import Earth from "../components/Earth";
import Scene from "../Scene";
import Lights from "../components/Lights";
import { useRecoilState } from "recoil";
import { changeColorState, weatherData } from "../utils/atom";
import { cities } from "../utils/cities";
import { fetchCityWeather } from "../utils/weatherApi";
import Title from "../components/Title";
import AnimatedOutlet from "../components/AnimatedOutlet";

const env = process.env;
env.PUBLIC_URL = env.PUBLIC_URL || "";

const Home = () => {
  const [content, setContent] = useRecoilState(weatherData);
  const [colorState, setColorState] = useRecoilState(changeColorState);
  const location  = useLocation()

  useEffect(() => {
    getCitiesWeather();
  }, []);

  useEffect(() => {
    if(location.pathname == "/"){
      setColorState("radial-gradient(circle, rgb(83, 173, 241) 0%, rgb(12, 73, 187) 100%)");
    }
  }, [location]);

  const getCitiesWeather = () => {
    const promises = cities?.map((city) => {
      return fetchCityWeather(city);
    });
  
    Promise.all(promises)
      .then((weatherDataArray) => {
        setContent(weatherDataArray);
      })
      .catch((error) => {
        console.error("Error Api", error);
      });
  };

  return(
      <motion.main initial={{background: colorState}} animate={{background: colorState}} transition={{delay: 0.8}}>
        <Title/>
        <Canvas camera={{position: [0, 0, 30], fov: 45}}>
          <Suspense fallback={<Html center>loading</Html>}>
            <Lights/>
            <Scene content={content}/>
          </Suspense>
          <Clouds/>
          <Earth/>
          <OrbitControls
            makeDefault
            enablePan={false}
            minAzimuthAngle={-Math.PI / 4}
            maxAzimuthAngle={Math.PI / 4}
            minPolarAngle={Math.PI / 6}
            maxPolarAngle={Math.PI - Math.PI / 6}
            maxDistance={50}
            minDistance={15}/>
        </Canvas>
        <AnimatePresence initial={false}>
          <AnimatedOutlet key={location.pathname}/>
        </AnimatePresence>
      </motion.main>
    )
}

export default Home